import * as React from 'react'

import EvidencePromotionCard from './evidence_promotion_card'
import SchoolYearUpdatesCard from './school_year_updates_card'
import { relevantYear, } from './shared'

const PromotionalCard = ({ userId, showEvidencePromotionCard, passedSchoolYearUpdatesCardClosed, }) => {
  const schoolYearUpdatesCard = `${relevantYear}SchoolYearUpdatesCardClosedForUser${userId}`

  const [schoolYearUpdatesCardClosed, setSchoolYearUpdatesCardClosed] = React.useState(window.localStorage.getItem(schoolYearUpdatesCard) || passedSchoolYearUpdatesCardClosed)

  function handleCloseSchoolYearUpdatesCard() {
    window.localStorage.setItem(schoolYearUpdatesCard, 'true')
    setSchoolYearUpdatesCardClosed(true)
  }

  if (!schoolYearUpdatesCardClosed) {
    return <SchoolYearUpdatesCard handleCloseCard={handleCloseSchoolYearUpdatesCard} />
  } else if (showEvidencePromotionCard) {
    return <EvidencePromotionCard />
  } else {
    return <span />
  }

}

export default PromotionalCard
